export default "__VITE_ASSET__409428d5__"